define('modules/includes_editor/views/list_item',['require','exports','module','base/itemview','ldsh!../templates/list_item'],function(require, exports, module){
  "use strict";
  var ItemView = require("base/itemview");
  module.exports = ItemView.extend({
    template: require("ldsh!../templates/list_item"),
    className: "include-editor-item",
    events: {
      "click": "selectItem"
    },
    selectItem: function(e){
      this.editorState.set("selectedItem", this.model);
    },

    initialize: function(options){
      this.editorState = options.parent.editorState;
      this.listenTo(this.editorState, "change:selectedItem", this.onSelectedItemChange);
    },
    //mark as selected
    onSelectedItemChange: function(model,value){
      this.$el.toggleClass("selected", this.model === value);
    }
  });
});

